import { Injectable, inject } from "@angular/core";
import { Meta } from "@angular/platform-browser";

@Injectable({ providedIn: 'root' })
export class ViewportService {
  #meta = inject(Meta);

  setDefaultViewport(): void {
    this.#meta.removeTag('name="viewport"');
    this.#meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1' });
  }

  setCarteViewport(): void {
    this.#meta.removeTag('name="viewport"');
    this.#meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=1 maximum-scale=1.0, user-scalable=0' });
  }
}
